import { AutoSuggest } from "@rio-cloud/rio-uikit";
import { AutoSuggestSuggestion } from "@rio-cloud/rio-uikit/components/autosuggest/AutoSuggest";
import { useRef } from "react";

interface Props {
    title: string;
    isRequired?: boolean;
    isLoading?: boolean;
    suggestions: AutoSuggestSuggestion[];
    handleSuggestionsFetchRequested: (result: { value: string }) => void;
    value: string;
}

const AutoInput = ({ title, isRequired, isLoading, suggestions, handleSuggestionsFetchRequested, value }: Props) => {
    
    const renderSuggestion = (suggestion: AutoSuggestSuggestion) => <span>{suggestion.label}</span>;

    const inputRef = useRef<HTMLInputElement | null>(null);

    return (
        <div className="width-100pct">
            <label htmlFor='1' className="text-size-12 text-normal line-height-18">{title}{isRequired ? <span className="text-color-danger"> *</span> : null}</label>
            <AutoSuggest
                id='3'
                className="width-100pct rounded-small"
                trailingInputAddons={[
                    <div key='addon-1' className='input-group-addon'>
                        <span className='rioglyph rioglyph-chevron-down' />
                    </div>
                ]}
                inputProps={{
                    placeholder: 'Digite aqui...',
                    value: value,
                    hasError: true,
                    inputRef: inputRef as any,
                    className: 'rounded-small border-color-primary'
                }}
                suggestions={suggestions}
                onSuggestionsFetchRequested={handleSuggestionsFetchRequested}
                renderSuggestion={renderSuggestion}
                closeOnSelect={true}
                isLoading={isLoading}
            />
        </div>
    )
}

export default AutoInput;